
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../../store/httpClient";

@Component
export default class UpdateBoundingBoxCommand extends Vue {
	@Prop()
	private articleId!: number;

	private updateBoundingBoxRunning: boolean = false;

	private async updateBoundingBox() {
		try {
			this.updateBoundingBoxRunning = true;
			await httpClient().post(`Article/UpdateBoundingbox?articleId=${this.articleId}`);
			this.$store.commit(
				"setSnackbarText",
				"Grösse erfolgreich neu berechnet und gespeichert."
			);
		} catch {
			console.error("Update boundingbox failed.");
			this.$store.commit("setSnackbarErrorText", "Fehler bei der Neuberechnung der Grösse.");
		} finally {
			this.updateBoundingBoxRunning = false;
		}
	}
}
